import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Select, Space, Table, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { maskingRrn, priceToString } from '../../util/utils';

const StyledDiv = styled.div`
  .ant-table table {
    font-size: 14px;
  }
  .ant-table-tbody > tr > td {
    height: 5px;
    padding: 4px;
  }
  /* row tags */
  .my-tag {
    font-size: 12px;
  }
  .ant-table-thead > tr > th {
    height: 5px;
    padding: 4px;
  }
  .ant-table-summary > tr > td {
    height: 5px;
    padding: 4px;
  }
`;

const { Option } = Select;

interface DirectWorkerListComponentProps {
  data: any;
  // downloadFile: (data: any) => void;
  openDirectWorkerDownloadXlsxModal: () => void;
}

function DirectWorkerListComponent({
  data,
  // downloadFile,
  openDirectWorkerDownloadXlsxModal,
}: DirectWorkerListComponentProps) {
  const [form] = Form.useForm();
  const [gongjongListOptions, setGongjongListOptions] = useState<any[]>();
  const [jigjongListOptions, setJigjongListOptions] = useState<any[]>();
  const [directWorkerList, setDirectWorkerList] = useState(
    data.directWorkerList,
  );

  useEffect(() => {
    let children: any = [];
    let index = 0;
    for (const gongjong of data.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={index} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
      index++;
    }
    setGongjongListOptions(children);

    children = [];
    index = 0;
    for (const jigjong of data.jigjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={index} value={jigjong.name}>
          {jigjong.name}
        </Option>,
      );
      index++;
    }
    setJigjongListOptions(children);
  }, [data]);

  const onSearch = (values: any) => {
    console.log(values);
    setDirectWorkerList(
      data.directWorkerList.filter((record: any) => {
        if (values.gongjong && values.jigjong) {
          return (
            record.gongjong === values.gongjong &&
            record.jigjong === values.jigjong
          );
        } else if (values.gongjong) {
          return record.gongjong === values.gongjong;
        } else if (values.jigjong) {
          return record.jigjong === values.jigjong;
        }
        return record;
      }),
    );
  };

  const columns: ColumnsType<any> = [
    {
      title: '성명',
      dataIndex: 'name',
      width: '10%',
    },
    {
      title: '주민등록번호',
      dataIndex: 'residentNumber',
      ellipsis: true,
      align: 'center',
      width: '12%',
      render: (text, record, index) => {
        return maskingRrn(record.residentNumber);
      },
    },
    {
      title: '주소',
      dataIndex: 'address',
      ellipsis: true,
      align: 'center',
      width: '15%',
    },
    {
      title: '휴대전화번호',
      dataIndex: 'personalPhoneNumber',
      ellipsis: true,
      align: 'center',
      width: '10%',
    },
    {
      title: '공정',
      dataIndex: 'gongjong',
      align: 'center',
      ellipsis: true,
      width: '8%',
    },

    {
      title: '직종',
      dataIndex: 'jigjong',
      align: 'center',
      ellipsis: true,
      width: '7%',
    },
    {
      title: '출역상황일',
      align: 'center',
      width: '30%',
      render: (text, record, index) => {
        return record.workDayList.map((tag: any, index: any) => (
          <Tag key={index}>
            {dayjs(tag.workDay).format('MM/DD')}({tag.numOfGongsu})
          </Tag>
        ));
      },
    },
    {
      title: '출역일수',
      dataIndex: 'totalNumOfGongsu',
      align: 'center',
      width: '7%',
    },
    {
      title: '단가',
      dataIndex: 'price',
      align: 'center',
      width: '7%',
      render: (text, record, index) => {
        return priceToString(record.price);
      },
    },
    {
      title: '합계금액',
      align: 'center',
      dataIndex: 'totalPrice',
      width: '10%',
      render: (text, record, index) => {
        return priceToString(record.price * record.totalNumOfGongsu);
      },
    },
  ];

  console.log(data);

  return (
    <StyledDiv>
      <Row>
        <Col>
          <Title level={3}>출역현황</Title>
        </Col>
      </Row>
      <Row justify={'space-between'} style={{ height: '20px' }}>
        <Space>
          <Form
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form"
            layout="inline"
            size="small"
            onFinish={onSearch}
          >
            <Col flex={6}>
              {/* <Form.Item name="name">
                <Input
                  placeholder="공사명을 입력 후 엔터키를 누르세요."
                  style={{ width: '300px' }}
                  allowClear
                />
              </Form.Item> */}
              <Form.Item name="gongjong" label="공정">
                <Select style={{ width: '150px' }} allowClear>
                  {gongjongListOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col flex={4}>
              {/* <Form.Item name="owner">
                <Input
                  placeholder="발주처명을 입력 후 엔터키를 누르세요."
                  style={{ width: '200px' }}
                  allowClear
                />
              </Form.Item> */}
              <Form.Item name="jigjong" label="직종">
                <Select style={{ width: '100px' }} allowClear>
                  {jigjongListOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col flex={1}>
              <Button
                htmlType="submit"
                icon={<SearchOutlined rev={undefined} />}
              >
                검색
              </Button>
            </Col>
          </Form>
        </Space>

        <Col>
          <Button
            size="small"
            icon={<DownloadOutlined rev={undefined} />}
            onClick={() => openDirectWorkerDownloadXlsxModal()}
          >
            다운로드
          </Button>
        </Col>
      </Row>
      <Row style={{ height: '95%', marginTop: '10px' }}>
        <Col span={24}>
          {directWorkerList && (
            <Table<any>
              rowKey="id"
              columns={columns}
              dataSource={directWorkerList}
              pagination={false}
              summary={(pageData) => {
                let _totalNumOfGongsu = 0;
                let _totalPrice = 0;

                pageData.forEach(({ totalNumOfGongsu, price }) => {
                  _totalNumOfGongsu += totalNumOfGongsu;
                  _totalPrice += totalNumOfGongsu * price;
                });
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}></Table.Summary.Cell>
                      {/* <Table.Summary.Cell index={1}></Table.Summary.Cell> */}
                      {/* <Table.Summary.Cell index={1}></Table.Summary.Cell> */}
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        합계:
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="center">
                        {_totalNumOfGongsu}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="center">
                        -
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="center">
                        {priceToString(_totalPrice)}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          )}
        </Col>
        {/* <Col
          span={5}
          style={{
            border: '2px solid #bcbcbc',
            padding: '5px',
            height: '500px',
          }}
        >
          <Form
            form={form}
            name="advanced_search"
            layout="vertical"
            size="small"
            onFinish={onSearch}
          >
            <Row
              justify={'center'}
              style={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <Button
                htmlType="submit"
                icon={<SearchOutlined rev={undefined} />}
                style={{ width: '60%' }}
              >
                검색
              </Button>
            </Row>

            <Form.Item name="gongjong" label="공정">
              <Select style={{ width: '100%' }} allowClear>
                {gongjongListOptions}
              </Select>
            </Form.Item>
            <Form.Item name="company" label="회사명">
              <Select style={{ width: '100%' }} allowClear>
                {companyListOptions}
              </Select>
            </Form.Item>
            <Form.Item name="jigjong" label="직종">
              <Select style={{ width: '100%' }} allowClear>
                {jigjongListOptions}
              </Select>
            </Form.Item>
          </Form>
        </Col> */}
      </Row>
    </StyledDiv>
  );
}

export default DirectWorkerListComponent;
